import { render } from "./menuMobile.vue?vue&type=template&id=5651e6a2&scoped=true"
import script from "./menuMobile.vue?vue&type=script&lang=js"
export * from "./menuMobile.vue?vue&type=script&lang=js"

import "./menuMobile.vue?vue&type=style&index=0&id=5651e6a2&scoped=true&lang=css"
import "./menuMobile.vue?vue&type=style&index=1&id=5651e6a2&lang=css"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5651e6a2"]])

export default __exports__